import { jwtDecode } from "jwt-decode";

/**
 * Schedule auto logout when JWT expires
 * @param {string} token - JWT token
 * @param {function} logoutCallback - Function to call on logout
 * @returns {number|null} timeoutId - The setTimeout ID (so it can be cleared)
 */
export function scheduleLogout(token, logoutCallback) {
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    const expiry = decoded.exp * 1000; // exp is in seconds, convert to ms
    const now = Date.now();
    const timeout = expiry - now;

    if (timeout > 0) {
      return setTimeout(() => {
        logoutCallback();
      }, timeout);
    } else {
      logoutCallback(); // already expired
    }
  } catch (e) {
    console.error("[scheduleLogout] Failed to decode token:", e);
    logoutCallback();
  }

  return null;
}
